// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6140":"5e5ec950","7071":"d5eeeb01","8185":"5e5ec950"}[chunkId] + ".chunk.css";
};